export const ClientGameApiRoute = {
  GetClientGames: (clientId: string) => `/cockpit-api/clients/${clientId}/games`,
} as const;
